import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import { getPathNames } from '../../common/router';
import './index.less';

class PageHeader extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
  };

  static defaultProps = {
    title: '',
    description: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      breadcrumb: null,
    };
  }

  componentDidMount() {
    this.getBreadCrumbs();
  }

  getBreadCrumbs = () => {
    const pathNames = getPathNames(this.props.path);
    this.setState({ breadcrumb: pathNames });
  };

  renderBreadcrumbs = () => {
    const breadcrumbDoms = this.state.breadcrumb.map((breadcrumb, i) => {
      // the current path shouldn't be a link
      if (i === this.state.breadcrumb.length - 1) {
        return <Breadcrumb.Item key={breadcrumb.path}>{breadcrumb.name}</Breadcrumb.Item>;
      }
      return (
        <Breadcrumb.Item key={breadcrumb.path}>
          <Link to={breadcrumb.path}>{breadcrumb.name}</Link>
        </Breadcrumb.Item>
      );
    });

    return <Breadcrumb className="breadcrumbs">{breadcrumbDoms}</Breadcrumb>;
  };

  render() {
    const { title, action, description, content } = this.props;

    return (
      <div className="page-header">
        {this.state.breadcrumb && this.renderBreadcrumbs()}
        <div className="detail">
          <div className="row">
            {title && <h1 className="title">{title}</h1>}
            {action && <div className="action">{action}</div>}
          </div>
          {description && <p className="description">{description}</p>}
          {content && (
            <div className="content">
              {content}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader/index.js